import { QueryKey, queryOptions, useQuery } from '@tanstack/react-query'
import {
  MccGroupListModel,
  MccGroupListResponse,
} from 'src/models/mccGroup.models'
import { getMccGroups } from 'src/queries/mccGroups.network'
import { MCC_GROUPS_QK } from 'src/queries/queries.constants'
import { ExtendBaseQueryOptions } from 'src/queries/queries.utils'

export interface GetMccGroupListResponse {
  mccGroups: MccGroupListResponse[]
}

export const mccGroupsQueries = {
  list: (additionalKey?: string) => {
    const queryKey: QueryKey = additionalKey
      ? [MCC_GROUPS_QK, additionalKey]
      : [MCC_GROUPS_QK]

    return queryOptions({
      queryKey,
      queryFn: () => getMccGroups(),
    })
  },
}

interface UseQueryMccGroupsProps
  extends ExtendBaseQueryOptions<
    GetMccGroupListResponse,
    MccGroupListModel[]
  > {
  additionalKey?: string
}

export const useQueryMccGroups = (props: UseQueryMccGroupsProps = {}) => {
  const { additionalKey, queryCacheOptions, ...rest } = props

  return useQuery({
    ...mccGroupsQueries.list(additionalKey),
    select: (data: GetMccGroupListResponse) =>
      data?.mccGroups.map(
        (mcc: MccGroupListResponse) => new MccGroupListModel(mcc),
      ),
    ...queryCacheOptions,
    ...rest,
  })
}
